import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, {
    staticClass: "pt-0 pbspec"
  }, [_c(VCard, {
    staticClass: "dtwin-card detail-card preview-card pa-2",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "text-caption preview-tile-center"
  }, [_c(VIcon, {
    class: _vm.color + '--text mr-1',
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-calendar-day")]), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.packetsToday')) + "\n          ")])], 1), _c('div', [_c('div', {
    staticClass: "preview-text-container"
  }, [_c('div', {
    staticClass: "preview-text text-truncate"
  }, [_vm.loading ? [_c(VProgressCircular, {
    attrs: {
      "size": 20,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })] : _c('div', [_vm._v(_vm._s(_vm.last24Hours))])], 2)])])])], 1), _c(VCol, {
    staticClass: "pt-0 pbspec"
  }, [_c(VCard, {
    staticClass: "dtwin-card detail-card preview-card pa-2",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "text-caption preview-tile-center"
  }, [_c(VIcon, {
    class: _vm.color + '--text mr-1',
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-history")]), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.packetsYesterday')) + "\n          ")])], 1), _c('div', [_c('div', {
    staticClass: "preview-text-container"
  }, [_c('div', {
    staticClass: "preview-text text-truncate"
  }, [_vm.loading ? [_c(VProgressCircular, {
    attrs: {
      "size": 20,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })] : _c('div', [_vm._v(_vm._s(_vm.prior24Hours))])], 2)])])])], 1), _c(VCol, {
    staticClass: "pt-0 pbspec"
  }, [_c(VCard, {
    staticClass: "dtwin-card detail-card preview-card pa-2",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "text-caption preview-tile-center"
  }, [_c(VIcon, {
    class: _vm.color + '--text mr-1',
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-hourglass-half")]), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.packetsPerHour')) + "\n          ")])], 1), _c('div', {
    staticClass: "preview-text-container"
  }, [_c('div', {
    staticClass: "preview-text text-truncate"
  }, [_vm.loading ? [_c(VProgressCircular, {
    attrs: {
      "size": 20,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })] : _c('div', [_vm._v(_vm._s(Math.floor(_vm.last24Hours / 2.4) / 10))])], 2)])])], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "pt-0 pbspec"
  }, [_c(VCard, {
    staticClass: "dtwin-card detail-card preview-card pa-2",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "text-caption preview-tile-center"
  }, [_c(VIcon, {
    class: _vm.color + '--text mr-1',
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-sensor-on")]), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnVirtualDevices')) + "\n          ")])], 1), _c('div', {
    staticClass: "preview-text-container"
  }, [_c('div', {
    staticClass: "preview-text text-truncate"
  }, [_vm.loading ? [_c(VProgressCircular, {
    attrs: {
      "size": 20,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })] : _c('div', [!(isNaN(_vm.devices) || _vm.devices === 0) ? _c('router-link', {
    class: {
      'non-empty': !(isNaN(_vm.devices) || _vm.devices === 0)
    },
    attrs: {
      "to": {
        name: 'VirtualDevicesList',
        query: {
          view: _vm.id,
          mode: 'devices'
        }
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.devices) + "\n              ")]) : [_c('div', [_vm._v(_vm._s(_vm.devices))])]], 2)], 2)])])], 1), _c(VCol, {
    staticClass: "pt-0 pbspec"
  }, [_c(VCard, {
    staticClass: "dtwin-card detail-card preview-card pa-2",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "text-caption preview-tile-center"
  }, [_c(VIcon, {
    class: _vm.color + '--text mr-1',
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-siren-on")]), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnErrors')) + "\n          ")])], 1), _c('div', {
    staticClass: "preview-text-container"
  }, [_c('div', {
    staticClass: "preview-text text-truncate"
  }, [_vm.loading ? [_c(VProgressCircular, {
    attrs: {
      "size": 20,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })] : _c('div', [!(isNaN(_vm.errors) || _vm.errors === 0) ? _c('router-link', {
    class: {
      'danger--text': !(isNaN(_vm.errors) || _vm.errors === 0)
    },
    attrs: {
      "to": {
        name: 'VirtualDevicesList',
        query: {
          view: _vm.id,
          mode: 'errors'
        }
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.errors) + "\n              ")]) : [_c('div', [_vm._v(_vm._s(_vm.errors))])]], 2)], 2)])])], 1), _c(VCol, {
    staticClass: "pt-0 pbspec"
  }, [_c(VCard, {
    staticClass: "dtwin-card detail-card preview-card pa-2",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "text-caption preview-tile-center"
  }, [_c(VIcon, {
    class: _vm.color + '--text mr-1',
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _c('span', {
    staticClass: "text-truncate"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.card.columnWarnings')) + "\n          ")])], 1), _c('div', {
    staticClass: "preview-text-container"
  }, [_c('div', {
    staticClass: "preview-text text-truncate"
  }, [_vm.loading ? [_c(VProgressCircular, {
    attrs: {
      "size": 20,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })] : _c('div', [!(isNaN(_vm.warnings) || _vm.warnings === 0) ? _c('router-link', {
    class: {
      'warning--text': !(isNaN(_vm.warnings) || _vm.warnings === 0)
    },
    attrs: {
      "to": {
        name: 'VirtualDevicesList',
        query: {
          view: _vm.id,
          mode: 'warnings'
        }
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.warnings) + "\n              ")]) : [_c('div', [_vm._v(_vm._s(_vm.warnings))])]], 2)], 2)])])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };